import { Dialog, Heading, IconButton, Badge } from '../../../components/base';
import { AipLogDetail, uploadTypeLabel } from '../../../libs/models/dashboard/aip/AipMonitoring';

interface AipDetailDialogProps {
  detail: AipLogDetail | null;
  onClose: () => void;
}

const formatDateTime = (iso: string) => iso.replace('T', ' ').slice(0, 19);

export const AipDetailDialog: React.FC<AipDetailDialogProps> = ({ detail, onClose }) => {
  if (!detail) return null;

  const orDash = (value?: string | null) => (value && value.trim() !== '' ? value : '-');

  const agentText = detail.agentName ? `${detail.agentName} (${detail.agentId ?? ''})` : detail.agentId;

  const rows: Array<{ tit: string; con: React.ReactNode }> = [
    { tit: '업로드 일시', con: formatDateTime(detail.uploadedAt) },
    { tit: '라벨명', con: detail.labelName },
    { tit: '파일명', con: detail.fileName },
    { tit: '업로드 방식', con: uploadTypeLabel[detail.uploadType] },
    { tit: '세션 ID', con: orDash(detail.sessionId) },
    // 임베딩 업로드일 때만 값이 있다.
    { tit: 'Agent', con: orDash(agentText) },
    {
      tit: '복호화 성공 여부',
      con: (
        <Badge variant="tint" size="large" accent={detail.isSuccess ? 'positive' : 'negative'}>
          {detail.isSuccess ? '성공' : '실패'}
        </Badge>
      ),
    },
  ];

  // 실패 시에만 사유 노출
  if (!detail.isSuccess && detail.failReason) {
    rows.push({ tit: '실패 사유', con: detail.failReason });
  }

  return (
    <Dialog isOpen={detail != null} onClose={onClose} className="aip-detail-view">
      <div className="read-detail">
        <div className="det-head">
          <Heading as="h2" size="title3" weight="semibold">
            업로드 상세
          </Heading>
          <IconButton name="closeLarge" className="d-close" onClick={onClose}>
            닫기
          </IconButton>
        </div>
        <div className="det-body">
          <ul className="aip-detail-list">
            {rows.map((row) => (
              <li key={row.tit}>
                <span className="tit">{row.tit}</span>
                <span className="con">{row.con}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Dialog>
  );
};

export default AipDetailDialog;
